import { IRectangle } from "@formant/core/model/IRectangle";

// V1 grids (Observe and Analytics both render through Modules.tsx) are 12
// columns with a viewport-dependent row height of roughly 86px. Coherence
// dashboards render 36 columns at a fixed 75px row height, so horizontal
// units triple while vertical units carry over roughly 1:1.
const v1Columns = 12;
const v2Columns = 36;
const columnScale = v2Columns / v1Columns;

// Minimum module sizes enforced by the coherence editor
// (see view-store-builder.ts: line chart 4x2, other modules 5x3).
const lineChartMinSize = { width: 4, height: 2 };
const defaultMinSize = { width: 5, height: 3 };

export function scaleV1RectToCoherenceGrid(
    rect: IRectangle,
    isLineChart: boolean,
): IRectangle {
    const min = isLineChart ? lineChartMinSize : defaultMinSize;
    return {
        x: Math.min(rect.x * columnScale, v2Columns - min.width),
        y: rect.y,
        width: Math.max(rect.width * columnScale, min.width),
        height: Math.max(rect.height, min.height),
    };
}
